<template>
<div>
  <div :style="cstyle" ref="map"></div>
  <slot v-if="map"></slot>
</div>
</template>

<script>
import leaflet from "./leaflet";

let L;

export default {
  name: "StandardMap",

  props: {
    "zoom": {
      type: Number,
      default: 12
    },
    "center": {
      type: Array
    },
    "minZoom": {
      type: Number,
      default: 6
    },
    "maxZoom": {
      type: Number,
      default: 20
    },
    "height": {
      type: Number,
      default: 36
    }
  },

  data() {
    return {
      map: null,
      url: "https://api.screenwork.de/tiles/{z}/{x}/{y}@2x.webp",
      initialized: false,
      L: null
    }
  },

  computed: {
    cstyle() {
      const s = {};
      s.height = this.height + "rem";
      s.zIndex = 1;

      return s;
    }
  },

  mounted() {
    let zoom = this.zoom;
    if (window.outerWidth < 576) {
      this.height = 20;
      zoom = 10;
    }

    L = leaflet;
    this.L = L;

    this.map = L.map(this.$refs.map, {
        minZoom: this.minZoom,
        maxZoom: this.maxZoom
    });

    const basemap = L.tileLayer(this.url, {
      attribution: "© OpenMapTiles © OpenStreetMap-Mitwirkende"
    });

    basemap.addTo(this.map);

    this.map.setView(this.center, zoom);

    this.map.scrollWheelZoom.disable(); // default

    this.$emit("load", this);
  },

  methods: {
    getMap() {
      return this.map;
    }
  }
};
</script>
